import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import {
  CreateNpsFamily,
  UpdateNpsFamily,
  FiltersNpsFamilies
} from '@/Network/Types/Requests/NpsRequests'
import { NpsFamilyResponse, ListNpsFamiliesResponse } from '@/Network/Types/Responses/NpsResponses'

export default class NpsFamilyService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/nps/families'
  }

  async create(payload: CreateNpsFamily): Promise<NpsFamilyResponse> {
    const response = await request.post<NpsFamilyResponse>(this.getCompletePath(), payload)
    return response.data
  }

  async update(familyId: number, payload: UpdateNpsFamily): Promise<NpsFamilyResponse> {
    const response = await request.put<NpsFamilyResponse>(
      `${this.getCompletePath()}/${familyId}`,
      payload
    )
    return response.data
  }

  async getById(familyId: number): Promise<NpsFamilyResponse> {
    const response = await request.get<NpsFamilyResponse>(`${this.getCompletePath()}/${familyId}`)
    return response.data
  }

  async delete(familyId: number): Promise<void> {
    await request.delete(`${this.getCompletePath()}/${familyId}`)
  }

  async list(filters?: FiltersNpsFamilies): Promise<ListNpsFamiliesResponse> {
    try {
      const { data } = await request.get<ListNpsFamiliesResponse>(this.getCompletePath(), filters)
      return data
    } catch (e) {
      return {
        count: 0,
        data: []
      }
    }
  }
}
